const theme = `
  <style>
    html, body {
      font-size: 14px;
      font-family: sans-serif;
    }

    * {
      cursor: pointer;
    }

    form {
      border: 2px dotted #2d81b1;
      margin: 8px 0px;
      position: relative;
      top: 4px;
      background: rgba(45, 129, 177, 0.1);
    } 

    form:before {
      content: 'form';
      background: #2d81b1;
      color: #fff;
      padding: 2px 4px;
      border-radius: 4px;
      font-family: sans-serif;
      font-size: 12px;
      position: absolute;
      top: -14px;
      left: 6px;
    }

    .box, .modal, .panel {
      border: 2px dotted #cb7856;
      margin: 16px 8px 28px 8px;
      position: relative;
      top: 8px;
    }

    .box {
      background-color: rgba(203, 120, 86, 0.1);
    }

    .modal {
      border-color: #2db181;
      background-color: rgba(45, 177, 129, 0.1);
    }

    .panel {
      border-color: #ffa71a;
      background-color: rgb(255, 167, 26, 0.1);
    }

    .box:before,
    .modal:before,
    .panel:before {
      content: 'div.box';
      background: #cb7856;
      color: #fff;
      padding: 2px 4px;
      border-radius: 4px;
      font-family: sans-serif;
      font-size: 12px;
      position: absolute;
      top: -14px;
      left: 6px;
    }

    .modal:before {
      content: 'div.modal';
      background: #2db181;
    }

    .panel:before {
      content: 'div.panel';
      background: #ffa71a;
    }
    
    th, td, div {
      margin: 8px 4px; border: 1px dotted #ccc;
      padding: 2px;
    } 
    
    [pp_active="true"] {
      position: relative;
      background: rgba(45,129,177, 0.2) !important;
    }

    [pp_active="true"] > * {
      background: rgba(0, 0, 0, 0.2);
    }

    *:focus {
      background: rgba(45,129,177, 0.3);
    }

    .container-fluid {
      border: none
    }

    ::-webkit-scrollbar {
      width: 14px;
    }

    ::-webkit-scrollbar-track {
      background: transparent;
      border-left: 1px solid rgba(0, 0, 0, 0.2);
    }

    ::-webkit-scrollbar-thumb {
      background: #888;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    } 

    @media (prefers-color-scheme: dark) {
      html, body {
        color: #fff;
      } 

      ::-webkit-scrollbar-track {
        background: transparent;
        border-left: 1px solid rgba(255, 255, 255, 0.2);
      }

      [pp_active="true"] {
        background: rgba(45,129,177, 0.7);
        position: relative;
      }

      [pp_active="true"] > * {
        background: rgba(255, 255, 255, 0.2);
      }

      th, td, div {
		    border-color: rgb(97, 97, 100); 
      } 

      input, select {
        background: rgb(64, 64, 67);
        color: #fff;
      }

      a {
        color: #2db181;
      }
    }
  </style>
`

export default theme;